import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { StorageService } from '../../managers/storage.service';
import { Observable } from 'rxjs';
import { Config } from '../config';
import { Contacts } from '../../../model/contacts';

@Injectable({
  providedIn: 'root'
})
export class ContactsService extends Config {

  constructor(private httpClient: HttpClient, private storage: StorageService) {
    super();
  }

  public getContacts(maxItemsPerPage: number, keyword: string, page: number): Observable<any> {
    let url;

    url = this.BASE_URL + 'contacts_get';

    if (maxItemsPerPage != null) {
      url += ("?maxItemsPerPage=" + maxItemsPerPage + (keyword != null ? "&keyword=" + keyword : "") + "&page=" + page);
    }

    return this.httpClient.get(url, this.storage.getHeaders());
  }

  public getContactNumbers(maxItemsPerPage: number, keyword: string, page: number, contactNumberID: number): Observable<any> {
    let url;
    let arr;

    url = this.BASE_URL + 'contacts_numbers_get?';
    arr = [];

    if (maxItemsPerPage != null) {
      url += "maxItemsPerPage=" + maxItemsPerPage +
        (keyword != null ? "&keyword=" + keyword : "") +
        (page != null ? "&page=" + page : "");
    } else if (contactNumberID != null) {
      url += "contact_number_id=" + contactNumberID;
    }

    return this.httpClient.get(url, this.storage.getHeaders());
  }

  public getContactNumbersByGroupID(groupID: number): Observable<any> {
    let url;
    let arr;

    url = this.BASE_URL + 'contacts_numbers_get_by_groupID?groups_id=' + groupID;

    return this.httpClient.get(url, this.storage.getHeaders());
  }
  //contacts_numbers_get_by_groupID

  public getContactsByGroupID(groups_id: number) {
    let url;

    url = this.BASE_URL + 'contacts_get_by_groupID?groups_id=' + groups_id;

    return this.httpClient.get(url, this.storage.getHeaders());
  }

  public getContactsOrGroups(keyword: string): Observable<any> {
    let url;

    url = this.BASE_URL + 'contacts_groups_get?keyword=' + keyword;

    return this.httpClient.get(url, this.storage.getHeaders());
  }

  public createContact(contact: any) {
    let url;

    url = this.BASE_URL + "contacts_store";

    return this.httpClient.post(url, contact, this.storage.getHeaders());
  }

  public getContactNumber(contact_id: number) {
    let url;

    url = this.BASE_URL + "contacts_get_mobile_number?contact_number_id=" + contact_id;

    return this.httpClient.get(url, this.storage.getHeaders());
  }

  public getContactNumberByConversationID(conversationID: number) {
    let url;

    url = this.BASE_URL + "contact_number_get_by_conversationID?conversation_id=" + conversationID;

    return this.httpClient.get(url, this.storage.getHeaders());
  }

  public getCount() {
    let url;

    url = this.BASE_URL + "count_contacts";

    return this.httpClient.get(url, this.storage.getHeaders());
  }
}
